/**
 * @desc Snowmaking layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import airwaterguns from "./airwaterguns";
import fanguns from "./fanguns";
import hydrants from "./hydrants";
import hydrantslabelless from "./hydrantslabelless";
import pipeleaks from "./pipeleaks";
import pipelines from "./pipelines";
import images from "./images";
import imagesunderground from "./imagesunderground";
import imagesmaintenance from "./imagesmaintenance";
import imagesoperations from "./imagesoperations";
import imagesother from "./imagesother";
import potable from "./potable";

export default {
  modules: {
    airwaterguns,
    fanguns,
    hydrants,
    hydrantslabelless,
    images,
    imagesunderground,
    imagesmaintenance,
    imagesoperations,
    imagesother,
    pipeleaks,
    pipelines,
    potable
  }
};
